import React, { useEffect, useState } from 'react';
import CompetitionWidget from "../../Componentsv1/CompetitionWidget"
import { useDispatch, useSelector } from 'react-redux';
import { View } from 'react-native';
import { Helmet } from 'react-helmet-async';
import { BracketRoom } from 'be-components';
import { BracketCompetitionProps } from '../../store/types/tp_svc';
import { comps_getBracketCompetitionById } from '../../store/actionsv1/comps';
import { V1_SHOW_AUTHENTICATE } from '../../store/actionsv1/types';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Colors from '../../constants/Colorsv2';
import { util_updateShare } from '../../store/actionsv1/utils';


const BracketPlayScreen2 = ({ route, navigation }:any) => {
    const [ bracket_competition, setBracketCompetition ] = useState<BracketCompetitionProps|undefined>()

    const dispatch = useDispatch();
    const insets = useSafeAreaInsets();
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    useEffect(() => {
        if(!route.params?.bracket_competition_id){ return }
        getDataFromServer(route.params.bracket_competition_id);
    },[route.params?.bracket_competition_id])

    const getDataFromServer = async(id:string) => {
        const bc = await comps_getBracketCompetitionById(id)
        setBracketCompetition(bc)
    }

    return (
        <View style={{ flex:1, paddingTop: insets.top, backgroundColor:Colors.shades.white }}>
            {bracket_competition ?
            <Helmet>
                <title>{bracket_competition.competition_name}</title>
                <meta name='description' content={bracket_competition.competition_description} />
                <meta name='og:image' content={bracket_competition.image?.url} />
            </Helmet>
            :<></>}
            <BracketRoom
                bracket_competition_id={route.params?.bracket_competition_id}
                player_id={player?.player_id}
                onNotEnoughBalance={(data) => alert(`Not enough balance to enter this competition.  Please make a deposit`)}
                onClose={() => navigation.goBack()}
                onShareCompetition={(bracket_competition_id) => {
                    if(!bracket_competition){ return }
                    dispatch(util_updateShare({
                        share_key: `bracket_${bracket_competition.bracket_competition_id}_share`,
                        visible:true,
                        title: `${bracket_competition.competition_name}`,
                        body: 'Compete against me for real money!',
                        type_id: bracket_competition.bracket_competition_id,
                        generator:'player',
                        link_type: 'user_generated_link',
                        link_sub_type: 'bracket_link',
                        redirect_url: `https://app.bettoredge.com/competition/brackets/play/${bracket_competition_id}`,
                    }))
                }}
                onRequestAuthenticate={() => dispatch({ type:V1_SHOW_AUTHENTICATE, show_authenticate: { visible: true, hide_close:false, nav_out:false } })}
            />
        </View>
    )
}

export default BracketPlayScreen2